<div
  class="z-[999] fixed inset-0 bg-black/50 backdrop-blur-xs flex items-center justify-center"
>
  <div
    class="bg-white w-[400px] xl:w-[450px] 2xl:w-[500px] min-h-[300px] xl:min-h-[340px] 2xl:min-h-[380px] max-h-[370px] xl:max-h-[415px] 2xl:max-h-[460px] overflow-hidden rounded-md xl:rounded-lg 2xl:rounded-lg flex flex-col
           3xl:w-[625px] 3xl:min-h-[480px] 3xl:max-h-[575px] 3xl:rounded-xl"
  >
    <div
      class="h-12 xl:h-[54px] 2xl:h-15 w-full px-3 xl:px-3.5 2xl:px-4 py-3 xl:py-3.5 2xl:py-4 flex justify-between
             3xl:h-[75px] 3xl:px-5 3xl:py-5"
      [ngClass]="allInfo.isActual ? 'bg-dimot-1' : 'bg-dimot-2'"
    >
      <h1 class="text-[0.95rem] xl:text-[1.05rem] 2xl:text-[1.15rem] text-white pl-1 3xl:text-[1.35rem] 3xl:pl-[6px]">
        {{ allInfo.region.name }} -
        {{ allInfo.datePoint.replaceAll("-", "/") }}
      </h1>

      <button class="shrink-0">
        <svg
          (click)="closeModal()"
          class="cursor-pointer w-4 h-4 xl:w-5 xl:h-5 2xl:w-[22px] 2xl:h-[22px] 3xl:w-[28px] 3xl:h-[28px]"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.1471 18.3525C19.2024 18.404 19.2467 18.4661 19.2775 18.5351C19.3082 18.6041 19.3248 18.6786 19.3261 18.7541C19.3274 18.8296 19.3135 18.9047 19.2852 18.9747C19.2569 19.0447 19.2148 19.1084 19.1614 19.1618C19.108 19.2152 19.0444 19.2573 18.9743 19.2856C18.9043 19.3139 18.8293 19.3278 18.7537 19.3265C18.6782 19.3251 18.6037 19.3086 18.5347 19.2778C18.4657 19.2471 18.4036 19.2028 18.3521 19.1475L11.9996 12.7959L5.64714 19.1475C5.54051 19.2469 5.39947 19.301 5.25375 19.2984C5.10802 19.2958 4.96898 19.2368 4.86592 19.1337C4.76286 19.0307 4.70383 18.8916 4.70126 18.7459C4.69869 18.6002 4.75278 18.4591 4.85214 18.3525L11.2037 12L4.85214 5.64751C4.75278 5.54088 4.69869 5.39984 4.70126 5.25411C4.70383 5.10839 4.76286 4.96935 4.86592 4.86629C4.96898 4.76323 5.10802 4.7042 5.25375 4.70163C5.39947 4.69905 5.54051 4.75315 5.64714 4.85251L11.9996 11.2041L18.3521 4.85251C18.4588 4.75315 18.5998 4.69905 18.7455 4.70163C18.8913 4.7042 19.0303 4.76323 19.1334 4.86629C19.2364 4.96935 19.2955 5.10839 19.298 5.25411C19.3006 5.39984 19.2465 5.54088 19.1471 5.64751L12.7956 12L19.1471 18.3525Z"
            fill="#ffffff"
          />
        </svg>
      </button>
    </div>

    <div class="overflow-hidden flex-1 flex flex-col">
      <table class="w-full table-fixed border-collapse">
        <thead class="sticky top-0 z-10 h-8 xl:h-9 2xl:h-10 3xl:h-[50px]">
          <tr
            [ngClass]="allInfo.isActual ? 'bg-[#E8EDF8]' : 'bg-[#E6FAF8]'"
            class="h-6 xl:h-7 2xl:h-8 3xl:h-10"
          >
            <th
              class="border-t-1 border-t-white text-left w-3/5 text-[#2d3d76] text-[0.65rem] xl:text-[0.71rem] 2xl:text-[0.77rem] pl-3 xl:pl-4 2xl:pl-5
                     3xl:text-[0.96rem] 3xl:pl-[25px]"
            >
              <h1>OSPEDALE</h1>
            </th>
            <th
              class="border-t-1 border-t-white text-center w-2/5 text-[#2d3d76] text-[0.6rem] xl:text-[0.65rem] 2xl:text-[0.71rem]
                     3xl:text-[0.89rem]"
            >
              <h1>DATA</h1>
            </th>
          </tr>
        </thead>
      </table>

      <div
        class="flex-1 overflow-y-auto"
        [ngClass]="allInfo.isActual ? 'scrollbar' : 'scrollbar2'"
      >
        <table class="w-full table-fixed border-collapse">
          <tbody>
            <tr *ngFor="let hospital of allInfo.region.hospitals" class="h-8 xl:h-9 2xl:h-10 3xl:h-[50px]">
              <td
                class="w-3/5 text-left text-dimot-1 text-[0.65rem] xl:text-[0.71rem] 2xl:text-[0.77rem] truncate pl-3 xl:pl-4 2xl:pl-5
                       3xl:text-[0.96rem] 3xl:pl-[25px]"
              >
                {{ hospital.name | hospitalTitlecase }} -
                {{ hospital.city | titlecase }}
              </td>
              <td class="w-2/5 text-center text-dimot-1 text-[0.6rem] xl:text-[0.65rem] 2xl:text-[0.71rem] pl-2 xl:pl-2.5 2xl:pl-3
                         3xl:text-[0.89rem] 3xl:pl-[15px]">
                {{ hospital.date | customDateFormat }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>